import React, { useState } from "react";
import { Card, Container, Row, Col, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";


function Contact() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [gallery, setGallery] = useState(false);
    const [activeImage, setActiveImage] = useState(false);
    return (
        <>
            <div className="product">
                <div class="container-fluid bg-dark p-0">
                    <div class="row gx-0 d-none d-lg-flex">
                        <div class="col-lg-7 px-5 text-start">
                            <div class="h-100 d-inline-flex align-items-center me-4">
                                <small class="fa fa-map-marker-alt text-primary me-2"></small>
                                <small>Opposite Safron Landmark, Beed Bypass, Aurangabad-431010</small>
                            </div>
                            <div class="h-100 d-inline-flex align-items-center">
                                <small class="far fa-clock text-primary me-2"></small>
                                <small>Mon - Fri : 09.00 AM - 09.00 PM</small>
                            </div>
                        </div>
                        <div class="col-lg-5 px-5 text-end">
                            <div class="h-100 d-inline-flex align-items-center me-4">
                                <small class="fa fa-phone-alt text-primary me-2"></small>
                                <small>7798121291</small>
                            </div>
                            <div class="h-100 d-inline-flex align-items-center mx-n2">
                                <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-linkedin-in"></i></a>
                                <a class="btn btn-square btn-link rounded-0" href=""><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Topbar End --> */}


                {/* <!-- Navbar Start --> */}
                <nav class="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
                    <a href="index.html" class="navbar-brand d-flex align-items-center border-end px-4 px-lg-5">
                        <img src="img/logo.jpeg" width="100" />
                    </a>
                    <button type="button" class="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarCollapse">
                        <div class="navbar-nav ms-auto p-4 p-lg-0">
                            <Link to="/"><a href="/" class="nav-item nav-link active">Home</a></Link>
                            <Link to="/about"> <a href="/about" class="nav-item nav-link">About</a></Link>
                            <div class="nav-item dropdown">
                                <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Service</a>
                                <div class="dropdown-menu bg-light m-0">
                                    <Link to="/enginerringServices"> <a href="/enginerringServices" class="dropdown-item">Engineering and Consultancy Service</a></Link>
                                    <Link to="/fireHydrant"><a href="/fireHydrant" class="dropdown-item">Fire Hydrant System</a></Link>
                                    <Link to="/firesprinkler"><a href="/firesprinkler" class="dropdown-item">Fire Sprinkler System</a></Link>
                                    <Link to="/fireAlarm"><a href="/fireAlarm" class="dropdown-item">Fire Alarm and Detection System</a></Link>
                                    <Link to="/publicAddress"><a href="/publicAddress" class="dropdown-item">Public Address System</a></Link>
                                    <Link to="/accessControl"><a href="/accessControl" class="dropdown-item">Access Control System</a></Link>
                                    <Link to="/transformerProtection"><a href="/transformerProtection" class="dropdown-item">Transformer Protection System</a></Link>
                                    <Link to="/integratedSecurity"><a href="/integratedSecurity" class="dropdown-item">Integrated Security System</a></Link>
                                </div>
                            </div>
                            <Link to="/contact"> <a href="/contact" class="nav-item nav-link">Contact</a></Link>
                        </div>
                    </div>
                </nav>
                {/* <!-- Navbar End --> */}







                {/* <!-- Page Header Start --> */}
                <div class="container-fluid page-header py-5 mb-5">
                    <div class="container py-5">
                        <h1 class="display-3 text-white mb-3 animated slideInDown">Contact</h1>
                        <nav aria-label="breadcrumb animated slideInDown">

                        </nav>
                    </div>
                </div>
                {/* <!-- Page Header End --> */}


                {/* <!-- Contact Start --> */}
                <div class="container-fluid bg-light overflow-hidden px-lg-0" style={{ margin: '6rem 0' }}>
                    <div class="container contact px-lg-0">
                        <div class="row g-0 mx-lg-0">
                            <div class="col-lg-6 contact-text py-5 wow fadeIn" data-wow-delay="0.5s">
                                <div class="p-lg-5 ps-lg-0">

                                    <h6 class="text-primary">Contact Us</h6>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <h3 class="mb-4">Head Office:</h3>
                                            <span className="mb-4" style={{ color: 'black' }}>G-1, Ground Floor, Laxmi Appt.,
                                                Kukde Layout, Nagpur-27</span><br /><br />
                                            <span style={{ color: 'black' }}>Contact:-7798121291</span><br /><br />
                                            <span style={{ color: 'black' }}>Email-<br /> services@ssfireengineers.com <br/>
                                            vinodp@ssfireengineers.com <br/> bhushana@ssfireengineers.com</span>

                                        </div>
                                        <div className="col-6">
                                            <h3 class="mb-4">Branch Office</h3>
                                            <span style={{ color: 'black' }}>Office no-611, Vastu Elite Square,, Opposite Safron Landmark, Beed Bypass, Aurangabad-431010</span><br />
                                            
                                            <span style={{ color: 'black' }}>Contact:-8530959015</span>

                                        </div>
                                    </div>
                                    <form>
                                        <div class="row g-3">
                                            <div class="col-md-6">
                                                <div class="form-floating">
                                                    <input type="text" class="form-control" id="name" placeholder="Your Name" />
                                                    <label for="name">Your Name</label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-floating">
                                                    <input type="email" class="form-control" id="email" placeholder="Your Email" />
                                                    <label for="email">Your Email</label>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="form-floating">
                                                    <input type="text" class="form-control" id="subject" placeholder="Subject" />
                                                    <label for="subject">Subject</label>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="form-floating">
                                                    <textarea class="form-control" placeholder="Leave a message here" id="message" style={{ height: '100px' }}></textarea>
                                                    <label for="message">Message</label>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <button class="btn btn-primary rounded-pill py-3 px-5" type="submit">Send Message</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col-lg-6 pe-lg-0" style={{ minHeight: '400px' }}>
                                <div class="position-relative h-100">
                                    <iframe class="position-absolute w-100 h-100" style={{ objectFit: 'cover' }}
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7443.638144901899!2d79.08363869976243!3d21.119778214026482!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf5924e6c2ef%3A0xb2362b12d6480d7e!2skukde%20layout%2C%20Rameshwari%2C%20Nagpur%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1654328117440!5m2!1sen!2sin"
                                        frameborder="0" allowfullscreen="" aria-hidden="false"
                                        tabindex="0"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Contact End --> */}
                {/* <!-- Footer Start --> */}
                <div class="container-fluid bg-dark text-body footer mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
                    <div class="container py-5">
                        <div class="row g-5">
                            <div class="col-lg-3 col-md-6">
                                <h5 class="text-white mb-4">Address</h5>
                                <p class="mb-2"><i class="fa fa-map-marker-alt me-3"></i>Office no-611, Vastu Elite Square,, Opposite Safron Landmark, Beed Bypass, Aurangabad-431010
                                    <br />Email-services@ssfireengineers.com
                                    <br />Phone:- 77981 21291</p>
                                <div class="d-flex pt-2">
                                    <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-twitter"></i></a>
                                    <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-facebook-f"></i></a>
                                    <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-youtube"></i></a>
                                    <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <h5 class="text-white mb-4">Quick Links</h5>
                                <a class="btn btn-link" href="/">Home</a>
                                <a class="btn btn-link" href="/about">About Us</a>
                                <a class="btn btn-link" href="/contact">Contact Us</a>
                            </div>

                            <div class="col-lg-3 col-md-6">
                                <h5 class="text-white mb-4">Newsletter</h5>
                                <div class="position-relative mx-auto" style={{ maxwidth: '400px' }}>
                                    <input class="form-control border-0 w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                                    <button type="button" class="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="copyright">
                            <div class="row">
                                <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                                    &copy; <a href="#">SS FIRE ENGINEERS</a>, All Right Reserved.
                                </div>
                                <div class="col-md-6 text-center text-md-end">
                                    {/* This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support.  */}
                                    Designed By <a href="#">BFI</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;

